<template>
  <gj-modal
      size="400Auto"
      :visible.sync="modalVisible"
      :confirm-loading="confirmLoading"
      @cancel="cancel"
      @confirm="confirm">
    <template #header>新增广告组合</template>
    <template #content>
      <el-form
          ref="form"
          :model="form"
          style="margin: 20px 0;"
          label-width="100px">
        <el-form-item
            label="广告组合名称"
            prop="name"
            :rules="[
              { required: true, validator: validatorName, trigger: ['blur', 'change'] }
            ]">
          <gj-input
              v-model="form.name"
              class="form-input"
              width="100%"
              placeholder="请输入广告组合名称"
          ></gj-input>
        </el-form-item>
      </el-form>
    </template>
  </gj-modal>
</template>

<script>
  import { formRuleMixin, modalMixIn } from "@/minxins";
  import { Portfolios } from "@/api/ad";

  export default {
    name: "app-add-portfolio-modal",
    mixins: [modalMixIn, formRuleMixin],
    props: {
      marketId: {
        required: true
      }
    },
    data() {
      return {
        confirmLoading: false,
        form: {
          name: null,
          desc: null
        },
        validatorName: this._.debounce((rule, value, callback) => {
          if (!value) return callback(new Error('请输入广告组合名称'));
          const params = {
            marketId: this.marketId,
            name: value
          }
          Portfolios.existsByName(params)
            .then(({data}) => {
              data ? callback('广告组合名称已存在') : callback()
            })
            .catch(error => callback(error.message))
        }, 500),
      }
    },
    methods: {
      confirm() {
        this.confirmLoading = true;
        this.$refs.form.validate((valid) => {
          if (valid) {
            const params = {
              marketId: this.marketId,
              params: [{ name: this.form.name }]
            }
            Portfolios.setPortfolios(params)
              .then(({ msg }) => {
                this.$gjMessage.success(msg);
                this.$emit('created');
                this.$gjModal.$gjDestroy();
              })
              .complete(() => {
                this.confirmLoading = false;
              });
            }else {
              this.confirmLoading = false;
            }
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ .el-dialog__body{
    padding-bottom: 0;
  }
</style>
